import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {SelectItem} from 'src/shared/model/select-item';
import {ActivatedRoute} from '@angular/router';
import {LoaderService} from 'src/service/loader-service';
import {DOCUMENT} from '@angular/common';
import {HttpCustomService} from 'src/service/http-custom.service';
import * as _ from 'lodash';
import {AuthService} from 'src/authentication/service/auth.service';
import {Subject, Subscription} from 'rxjs';
import {CommonConstants} from 'src/shared/constants/common-constants.enum';
import {INavData} from 'src/sidebar';
import {Cooperative} from 'src/shared/model/cooperative';
import {NavDataService} from "../../shared/service/nav-data.service";
import {API} from "../../shared/apis/api";
import {takeUntil} from "rxjs/operators";
import {RoleTypeEnum} from "../../shared/constants/role-type.enum";

@Component({
  selector: 'dcu-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  public navItems: INavData[] = [];
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;
  homeTitle: string;
  subscriptions: Subscription[] = [];

  options: SelectItem[] = [];
  cooperativeList: Cooperative[];
  cooperativeNo: string;
  ngUnsubscribe: Subject<boolean> = new Subject();
  roleType: string;

  constructor(
    private loaderService: LoaderService,
    private http: HttpCustomService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private navDataService: NavDataService,
    @Inject(DOCUMENT) document?: any,
  ) {
    // load unit and station here
    this.cooperativeNo = JSON.parse(localStorage.getItem(CommonConstants.USER_COOPERATIVE_NO));
    this.initTreeData();
    this.changes = new MutationObserver(mutations => {
      this.sidebarMinimized = document.body.classList.contains(
        'sidebar-minimized'
      );
    });
    this.element = document.body;
    this.changes.observe(this.element as Element, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  ngOnInit(): void {
    this.roleType = localStorage.getItem(CommonConstants.ROLE_TYPE);
    this.loaderService.hide();
    this.subscriptions.push(this.navDataService.refreshDataEmitted.takeUntil(this.ngUnsubscribe).subscribe(change => this.initTreeData()));
  }

  initTreeData() {
    this.http.get({path: API.COOPERATIVE_LIST})
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(res => {
        this.cooperativeList = res;
        this.initNav();
      })
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.unsubscribe();
  }

  unsubscribe(): void {
    _.forEach(this.subscriptions, sub => {
      sub.unsubscribe();
    });
    this.subscriptions = [];
  }

  onLogout(): void {
    this.authService.logout();
  }

  initNav() {
    this.navItems = [];
    if (RoleTypeEnum.ADMIN === this.roleType) {
      this.navItems.push({
        name: 'Quản lý HTX',
        icon: 'pw-addnew',
        url: '/meter-cooperative/cooperative',
        class: 'manage-cooperative',
      });
    }
    if (RoleTypeEnum.COOPERATIVE === this.roleType) {
      this.navItems.push({
        name: 'Quản lý Trạm',
        icon: 'pw-addnew',
        url: `/meter-cooperative/cooperative/${this.cooperativeNo}`,
        class: 'manage-cooperative',
      });
    }
    this.cooperativeList && this.cooperativeList.forEach(cooperative => {
      this.navItems.push({
        icon: 'pw-masterdata',
        name: cooperative.cooperativeCode,
        url: '/meter-cooperative',
        children: [],
        cooperativeNo: cooperative.cooperativeNo
      })
    });
  }
}
